import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, Company, EmployeeCode, UserCode, EmployeeId } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { getIP } from '../../../utils/index';
import { encryption } from '../../../utils/encryption';

export function listDocuments(documentType, documentFolder) {
    let url = 'wage/listDocuments?' + objectToQueryString({ userCode: encryption(UserCode()), EmployeeId: encryption(EmployeeId()), documentType: encryption(documentType), documentFolder: encryption(documentFolder), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listWage() {
    let url = 'wage/listWage?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), EmployeeId: EmployeeId(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let wage = response.list;

                //saveConfig(wage);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listLotWage(lotId) {
    let url = 'wage/listLotWage?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), EmployeeId: EmployeeId(), lotId: lotId, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let wage = response.list;

                //saveConfig(wage);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listDepositWage(depositDate) {
    let url = 'wage/listDepositDateWage?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), EmployeeId: EmployeeId(), depositDate: depositDate, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let wage = response.list;

                //saveConfig(wage);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listDistributedDocuments() {
    let url = 'wage/listDistributedDocuments?' + objectToQueryString({ userCode: encryption(UserCode()), EmployeeId: encryption(EmployeeId()), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            return errorResponse([]);
        })
}

export function confirmReading(documentEmployeeId) {
    const param = JSON.stringify({
        userCode: UserCode(),
        documentEmployeeId: documentEmployeeId,
        token: Token()
    });

    return fetch('wage/confirmReading', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: param
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export async function confirmOpenningDocument(documentEmployeeId) {
    const ip = await getIP();

    const param = JSON.stringify({
        userCodeCrypt: encryption(UserCode()),
        documentEmployeeIdCrypt: encryption(documentEmployeeId),
        ipAddress: ip,
        token: Token()
    });

    return fetch('wage/ConfirmOpenningDocument', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: param
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

function saveScheduler(config) {
    localStorage.setItem('wageScheduler', JSON.stringify(config));
}